import { render, staticRenderFns } from "./QuestionContentView.vue?vue&type=template&id=70c96870&scoped=true"
import script from "./QuestionContentView.vue?vue&type=script&lang=js"
export * from "./QuestionContentView.vue?vue&type=script&lang=js"
import style0 from "./QuestionContentView.vue?vue&type=style&index=0&id=70c96870&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70c96870",
  null
  
)

export default component.exports